import AuthCard from '../components/AuthCard/AuthCard';

function Signup() {
  return <AuthCard mode="signup" />;
}

export default Signup;
